/* eslint-disable */
import { rootApi } from '../rootApi';

export const dealerAddressBrandPaymentApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllDealerAddressBrandPayment: builder.query({
            query: ({ dealerAddressBrandId, pageNumber = 1, pageSize = 10 }) => ({
                url: 'v1/dealeraddressbrandpayment/getlist',
                method: 'POST',
                body: {
                    dealerAddressBrandId,
                    pageNumber,
                    pageSize
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        count: response.data.totalCount || 0
                    };
                }
                return { items: [], count: 0 };
            },
            providesTags: ['DealerAddressBrandPayment']
        }),

        getByIdDealerAddressBrandPayment: builder.query({
            query: (id) => ({
                url: 'v1/dealeraddressbrandpayment/getbyid',
                method: 'POST',
                body: { id }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    return response.data;
                }
                return {};
            },
            providesTags: (result, error, id) => [{ type: 'DealerAddressBrandPayment', id }]
        }),

        createDealerAddressBrandPayment: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandpayment/save',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandPayment', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        updateDealerAddressBrandPayment: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandpayment/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandPayment', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        deleteDealerAddressBrandPayment: builder.mutation({
            // Hem sayısal id hem { id, dealerAddressBrandId } kabul edilir (id request'e gider,
            // dealerAddressBrandId yalnızca hedefli cache invalidation için kullanılır).
            query: (arg) => {
                const id = arg && typeof arg === 'object' ? arg.id : arg;
                return {
                    url: 'v1/dealeraddressbrandpayment/delete',
                    method: 'DELETE',
                    params: { id }
                };
            },
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandPayment', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        getDealerPaymentCurrency: builder.query({
            // Geriye uyumlu: parametresiz çağrı (AppBranchId fallback) hâlâ çalışır.
            // Bayi kayıt ekranında dealerAddressBrandId gönderilmeli.
            query: (arg = {}) => {
                const { dealerAddressBrandId, sapDealerId } = arg && typeof arg === 'object' ? arg : {};
                return {
                    url: 'v1/dealeraddressbrandpayment/getdealerpaymentcurrency',
                    method: 'GET',
                    params: {
                        ...(dealerAddressBrandId ? { dealerAddressBrandId } : {}),
                        ...(sapDealerId ? { sapDealerId } : {})
                    }
                };
            },
            transformResponse: (response, _meta, arg) => {
                const hasAnchor = !!(arg && typeof arg === 'object' && (arg.dealerAddressBrandId || arg.sapDealerId));
                if (response?.data?.currency) {
                    const currency = response.data.currency;
                    return {
                        currency,
                        defaultCurrency: currency,
                        currencyOptions: [{ label: currency, value: currency }],
                        sapDealerId: response.data.sapDealerId ?? null,
                        kunnr: response.data.kunnr ?? null
                    };
                }
                // Parametreli çağrıda SAP değeri yoksa null dön (varsayılan doldurulmaz).
                // Parametresiz çağrıda (garanti formları) TRY fallback korunur.
                if (hasAnchor) {
                    return {
                        currency: null,
                        defaultCurrency: null,
                        currencyOptions: [],
                        sapDealerId: response?.data?.sapDealerId ?? null,
                        kunnr: response?.data?.kunnr ?? null
                    };
                }
                return {
                    currency: 'TRY',
                    defaultCurrency: 'TRY',
                    currencyOptions: [
                        { label: 'TRY', value: 'TRY' },
                        { label: 'USD', value: 'USD' },
                        { label: 'EUR', value: 'EUR' }
                    ],
                    sapDealerId: null,
                    kunnr: null
                };
            }
        })
    })
});

export const {
    useGetAllDealerAddressBrandPaymentQuery,
    useGetByIdDealerAddressBrandPaymentQuery,
    useCreateDealerAddressBrandPaymentMutation,
    useUpdateDealerAddressBrandPaymentMutation,
    useDeleteDealerAddressBrandPaymentMutation,
    useGetDealerPaymentCurrencyQuery
} = dealerAddressBrandPaymentApi;
